<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت درخواست خرید</h5>
    <form [formGroup]="AddNewProduct">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_Product(templateProduct)"
              class="btn btn-danger left"> انتخاب کالا <i class="fa fa-sticky-note"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Product_Record.title}}" />
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">تعداد</label>
          <input formControlName="Amount" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Amount().valid && get_Form_Amount().touched"
            class="form-text text-muted MyErrorRedColor">تعداد را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">قیمت تقریبی</label>
          <input formControlName="Price" type="number" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Price().valid && get_Form_Price().touched"
            class="form-text text-muted MyErrorRedColor">قیمت تقریبی را وارد نمائید.</small>
        </div>
        <button type="button" class="btn btn-success" (click)="OnAdd_ProductRequestDetail()" ><i class="fa  fa-plus-circle"></i> افزودن کالا </button>
      </div>

      <br />

      <div class="table-responsive" *ngIf="DataList_ProductRequestDetail.length>0">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام کالا</th>
              <th>تعداد</th>
              <th>قیمت تقریبی (ريال)</th>
              <th>جمع (ريال)</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ProductRequestDetail">
             <td>{{DataList_ProductRequestDetail.indexOf(item)+1}}</td>

              <td>{{item.title}}</td>
              <td>{{item.amount}}</td>
              <td>{{item.price|number}}</td>
              <td>{{(item.price*item.amount)|number}}</td>
              <td>
                <button type="button" class="btn btn-danger" (click)="Delete_ProductRequestDetail(DataList_ProductRequestDetail.indexOf(item))" > حدف کالا </button>
              </td>
            </tr>
            <tr>
              <td colspan="2">جمع کل (ريال)</td>
              <td colspan="4">{{Total_Price_Detail|number}}</td>
            </tr>
          </tbody>
        </table>
     </div>

      <br />
      <hr />
      <br />

      <div class="row">

        <div class="form-group col-md-12">
          <label for="exampleInputEmail1">توضیحات</label>
          <input formControlName="Dsc" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched"
            class="form-text text-muted MyErrorRedColor">توضیحات را وارد نمائید.</small>
        </div>

      </div>



    </form>

    <br />
    <hr />
    <br />

    <h5 class="card-title">مشخصات موردنظر</h5>

    <div class="row">

      <div class="input-group mb-12" *ngFor="let item of Datalist_Dsc" style="margin: 5px;">
        <div class="input-group-prepend" (click)="Remove_Dsc(Datalist_Dsc.indexOf(item))">
          <div class="input-group-text">
            <i class="fa fa-remove" style="color: red;"></i>
          </div>
        </div>
        <input type="text" [(ngModel)]="item.title" name="" class="form-control" id="inlineFormInputGroup"
          placeholder="متن خود را وارد نمائید ...">
      </div>


      <div class="input-group mb-12" style="margin: 5px;">
        <button (click)="Add_Dsc()" type="button" class="btn btn-info" style="margin-left: 5px;"><i
            class="fa  fa-plus-circle"></i> ثبت ردیف جدید </button>
      </div>


    </div>

    <br />
    <hr />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="SubmitAddNewProduct()" *ngIf="!InProccessing" type="button" [disabled]="!AddNewProduct.valid"
      class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
    <button routerLink="/ProductRequest" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
        class="fa fa-mail-reply"></i> بازگشت </button>

  </div>
</div>


<ng-template #templateProduct>
  <div class="modal-header">
    <h4 class="modal-title pull-left">لیست اطلاعات کالا ها </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Product.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> کلید واژه </label>
          <input type="text" class="form-control" (keyup)="ReadData_Product_KeySearch()"
            [(ngModel)]="Search_Name_Product_Table" placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>نام کالا</th>
              <th>گروه کالا</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Product
            | paginate
                    : {
                        id: 'DataList_Product',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_Product).length
                      }">
              <td>{{DataList_Product.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.group_title}}</td>
              <td (click)="Set_Selected_Product_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingProduct" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!ProcssingProduct" type="button" (click)="ReadData_Product()" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Product.hide()">بستن</button>
  </div>
</ng-template>